import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import PickDate from "./common/datePicker";
import ProfileDatePicker from "./common/ProfileDatePicker";
import { useUpdateUserProfile } from "../hooks/updateUserProfile";
import { toast } from "react-toastify";
import "react-toastify/ReactToastify.css";
import {
  getEthnicity,
  getGender,
  getPreferredLanguage,
  getSex,
} from "../services/hcp_profile";

const EditPersonalDetails = ({ userProfile, isLoading, refetch }) => {
  const {
    updateProfile,
    isLoading: isUpdating,
    error,
  } = useUpdateUserProfile();
  const [birthDate, setBirthDate] = useState(
    userProfile?.dateOfBirth ? new Date(userProfile.dateOfBirth) : null
  );
  const [formData, setFormData] = useState();
  useEffect(() => {
    setBirthDate(
      userProfile?.dateOfBirth ? new Date(userProfile.dateOfBirth) : null
    );
    setFormData({
      id: userProfile?.id || "",
      firstName: userProfile?.firstName || "",
      middleName: userProfile?.middleName || "",
      lastName: userProfile?.lastName || "",
      ethnicity: userProfile?.ethnicity || "",
      dateOfBirth: userProfile?.dateOfBirth || "",
      gender: userProfile?.gender || "",
      languagePreference: userProfile?.languagePreference || "",
      workPhone: userProfile?.workPhone || "",
      workAddress: userProfile?.workAddress || "",
      homePhone: userProfile?.homePhone || "",
      workEmail: userProfile?.workEmail || "",
      homeAddress: userProfile?.homeAddress || "",
      homeEmail: userProfile?.homeEmail || "",
      mobilePhone: userProfile?.mobilePhone || "",
      preferredAddress: userProfile?.preferredAddress || "",
      preferredPhone: userProfile?.preferredPhone || "",
      preferredEmail: userProfile?.preferredEmail || "",
      email: userProfile?.email || "",
      sex: userProfile?.sex || "",
      temporaryAddress: userProfile?.temporaryAddress || "",
      temporaryAddressTimePeriod: userProfile?.temporaryAddressTimePeriod || "",
      emergencyContacts: userProfile?.emergencyContacts || [],
    });
  }, [userProfile]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setBirthDate(date);
    setFormData((prev) => ({
      ...prev,
      dateOfBirth: date.toISOString().split("T")[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Only send the fields that should be updated for personal details
      const updatedData = {
        id: formData.id,
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        ethnicity: formData.ethnicity,
        dateOfBirth: birthDate ? birthDate.toISOString().split("T")[0] : null,
        gender: formData.gender,
        languagePreference: formData.languagePreference,
        sex: formData.sex,
      };

      await updateProfile(updatedData);

      const isFirstLogin = window.location.pathname.includes("first_login_profile");
      if (!isFirstLogin) {
        toast.success("Personal details updated successfully!");
      }

      // Close modal using Bootstrap modal API
      const modal = document.getElementById("editPersonalDetails");
      if (modal) {
        window.$(modal).modal("hide");
        refetch();
      }
    } catch (error) {
      console.error("Failed to update profile:", error);
      // Show error toast
      toast.error("Failed to update personal details. Please try again.");
    }
  };
  return (
    <div
      className="modal fade"
      id="editPersonalDetails"
      tabindex="-1"
      aria-labelledby="editPersonalDetails"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <form onSubmit={handleSubmit}>
          <div className="modal-content border-0 overlay-rounded">
            <div className="modal-header mt-14 border-0">
              <label className="fs-15" id="editPersonalDetails">
                EDIT: Personal Details
              </label>

              <FaTimes
                size={15}
                className="cursor-pointer text_primary"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        First Name:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          value={formData?.firstName}
                          className="small-text overlay-input"
                          name="firstName"
                          onChange={handleInputChange}
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Middle Name:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          onChange={handleInputChange}
                          value={formData?.middleName}
                          name="middleName"
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Last Name:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          onChange={handleInputChange}
                          value={formData?.lastName}
                          name="lastName"
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Ethnicity:
                      </label>
                      <div className="col-md-8">
                        <select
                          type="text"
                          name="ethnicity"
                          className="small-text overlay-input"
                          value={formData?.ethnicity || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">— Select —</option>
                          {getEthnicity().map((ethnicity) => (
                            <option value={ethnicity.name}>
                              {ethnicity.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Biological Sex:
                      </label>
                      <div className="col-md-8">
                        <select
                          type="text"
                          name="sex"
                          className="small-text overlay-input"
                          value={formData?.sex || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">— Select —</option>
                          {getSex().map((sex) => (
                            <option value={sex.name}>{sex.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label className="col-md-4 col-form-label py-0">
                        Gender Identification:
                      </label>
                      <div className="col-md-8">
                        <select
                          type="text"
                          name="gender"
                          className="small-text overlay-input"
                          value={formData?.gender || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">— Select —</option>
                          {getGender().map((gender) => (
                            <option value={gender.name}>{gender.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Date of Birth:
                      </label>
                      <div className="col-md-8">
                        <ProfileDatePicker
                          date={birthDate}
                          setDate={handleDateChange}
                        />
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label className="col-md-4 col-form-label py-0">
                        Language Preference:
                      </label>
                      <div className="col-md-8">
                        <select
                          type="text"
                          name="languagePreference"
                          className="small-text overlay-input"
                          value={formData?.languagePreference || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">— Select —</option>
                          {getPreferredLanguage().map((language) => (
                            <option value={language.name}>
                              {language.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 d-flex justify-content-between">
              <button
                type="button"
                className="btn btn_outline_danger rounded overlay-btn"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-outline-primary rounded overlay-btn"
              >
                Save changes
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPersonalDetails;
